// Portfolio projects. `fullDescription` is trusted HTML authored here.
const projects = [
  {
    id: 1,
    title: 'Clarity Psychology Website',
    category: 'Web Development',
    description:
      'Professional psychology practice website designed to provide information about services and help clients connect with mental health professionals.',
    fullDescription: `
      <p>Clarity Psychology is a professional psychology practice website designed to provide a welcoming and informative online presence for clients seeking mental health services. The website serves as a digital gateway for the practice, offering information about services, therapist profiles, and ways to connect.</p>

      <h2>Key Features</h2>
      <ul>
        <li><strong>Professional Design:</strong> Clean, professional design that creates a welcoming and trustworthy atmosphere for potential clients</li>
        <li><strong>Service Information:</strong> Clear presentation of psychological services and treatment approaches</li>
        <li><strong>Client-Focused:</strong> User-friendly interface designed to help visitors easily find the information they need</li>
        <li><strong>Contact Integration:</strong> Easy ways for clients to reach out and schedule consultations</li>
        <li><strong>Responsive Layout:</strong> Optimized for all devices to ensure accessibility for all users</li>
      </ul>

      <h2>Project Goals</h2>
      <p>The website was designed to help Clarity Psychology establish a strong online presence, making it easy for clients to learn about available services and connect with mental health professionals. The focus was on creating a professional, approachable digital experience that reflects the practice's commitment to client care.</p>

      <h2>Results</h2>
      <p>This website provides Clarity Psychology with an effective online platform to showcase their services and connect with clients seeking mental health support. The professional design and user-friendly interface help build trust and facilitate client engagement.</p>
    `,
    image: '/portfolio/claritypsiholog.jpg',
    url: 'http://claritypsiholog.com',
    domain: 'claritypsiholog.com',
    technologies: ['Web Development', 'Responsive Design', 'User Experience'],
    date: '2026',
    client: 'Clarity Psychology',
    projectType: 'Psychology Practice Website',
    featured: true,
  },
  // Add more projects here
];

export const getProject = (id) => projects.find((project) => project.id === Number(id));

export default projects;
